import { Routes } from '@angular/router';
import { EditMdpComponent } from './edit-mdp.component';

export const EDIT_MDP_ROUTES: Routes = [
    {
        path: '',
        component: EditMdpComponent
    }
];
